import React from "react";
import { Button, DialogContentText, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

/** Message for a bid below the starting price. */
export default function InvalidBidDialog({
  handleCloseDialog,
  openNotif2,
}) {
  return (
    <Dialog
      className="single-product-bell-mt"
      open={openNotif2}
      onClose={handleCloseDialog}
      aria-labelledby="error-dialog-title"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        id="error-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          fontWeight: 600,
          color: "error.main",
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        <ErrorOutlineIcon color="error" sx={{ fontSize: 28 }} />
        Invalid Bid
      </DialogTitle>

      <DialogContent sx={{ mt: 1 }}>
        <DialogContentText id="alert-dialog-description">

          <Typography style={{ fontSize: 20 }} color="text.secondary">
            The bid is lower than the starting price. Please increase your
            bid above the starting price for it to be accepted.

          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ borderTop: "1px solid #f0f0f0" }}>
        <Button
          onClick={handleCloseDialog}
          variant="contained"
          sx={{ width: 100 }}
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
